import React, { FC, useEffect, useState } from "react";
import DataTable from 'react-data-table-component';
import {IonRow} from "@ionic/react";
import CSVDownloadButtonModal from "../../extras/CSVDownloadButtonModal";


interface IProps {
    id:string;
    data: any;
    name?: string;
    url: URL;
    type?:{
        id:string|number,
        name:string
    };
    handleFilters?:any;
    setUrl:any;
};



const VirtualMeterDataTable:FC<IProps> = (props) => {  
    const [tableData, setTableData] = useState(props.data.results)
    const [count, setCount] = useState(props.data.count)
    

    useEffect(()=>{
        setTableData(props.data.results)
        setCount(props.data.count)
    },[props.data])


    const getUsageCost = (row:any) => {
        const cost = row.cost ? row.cost : 0.00
        const demand_cost = row.demand_cost ? row.demand_cost : 0.00

        return Math.round((cost - demand_cost) * 100) / 100
    }
  

    const columns = [
    {
        name: 'Start Date',
        selector: (row:any) => {
            const date = new Date(row.startdate)
            return `${date.getUTCMonth()+1}/${date.getUTCDate()}/${date.getUTCFullYear()}`
        },
        sortable: true,
        sortField:'startdate'
    },
    {
        name: 'End Date',
        selector: (row:any) => {
            const date = new Date(row.enddate)
            return `${date.getUTCMonth()+1}/${date.getUTCDate()}/${date.getUTCFullYear()}`
        },
        sortable: true,
        sortField:'enddate'
    },
    {
            name: `Usage`,
            selector: (row:any) => (row.usage).toLocaleString(undefined, { maximumFractionDigits: 2 }),
            sortable: false,
        },
    {
            name: 'Cost',
            cell: (row:any) =>  `$${(getUsageCost(row)).toLocaleString(undefined, { maximumFractionDigits: 2 })}`,
            sortable: false,
            omit: props.type?.name !== "Electric"
        },
    {
            name: 'Demand',
            cell: (row:any) =>  row.demand ? `${(row.demand).toLocaleString(undefined, { maximumFractionDigits: 2 })}` : '',
            sortable: false,
            omit: props.type?.name !== "Electric"
        },
        {
            name: 'Demand Cost',
            cell: (row:any) =>  row.demand_cost ? `$${(row.demand_cost).toLocaleString(undefined, { maximumFractionDigits: 2 })}` : '',
            sortable: false,
            omit: props.type?.name !== "Electric"
        },
        {
            name: 'Total Cost',
            cell: (row:any) => row.cost ? `$${(row.cost).toLocaleString(undefined, { maximumFractionDigits: 2 })}` : '',                
            sortable: false,
        },
    ]

    const handlePageChange = (page:number) => {
        props.url.searchParams.set('page',(page.toString()))
        props.handleFilters(props.url.toString())
    }

    const handlePerRowsChange = (size:number) => {
        props.url.searchParams.set('page_size',(size.toString()))
        props.handleFilters(props.url.toString())
    }

    const handleSort = (column:any, sortDirection:string) => {
        props.url.searchParams.set(
            'sorting',column.sortField
        )
        props.url.searchParams.set(
            'sortDirection',sortDirection
        )        
        props.handleFilters(props.url)
    }

    const headers = [
        { label: "Start Date", key: "startdate" },
        { label: "End Date", key: "enddate" },
        { label: "Usage", key: "usage" },
        { label: "Demand", key: "demand"},
        { label: "Demand Cost", key: "demand_cost"},
        { label: "Total Cost", key: "cost"},
      ];

    
    const title = <div>
        <h2>Combined Consumption Data</h2>
        <IonRow className="ion-justify-content-end">
            <CSVDownloadButtonModal data={tableData} headers={headers} filename={`${props.name}_Combined_Meter_data.csv`} full_download_url={`virtual_meters/${props.id}/export_csv`} /> 
        </IonRow>                            
    </div>
    

    return <DataTable
              title={title}
              columns={columns}
              data={tableData || []}
              sortServer
              onSort={handleSort}
              pagination
              paginationServer
              paginationTotalRows={count}
              paginationPerPage={100}
              paginationRowsPerPageOptions={[100, 200, 500, 1000,10000]}
              onChangeRowsPerPage={handlePerRowsChange} 
              onChangePage={handlePageChange}
              theme='dark'                                
    
            />    
};

export default VirtualMeterDataTable;